// Mirrors psych_training_app_BE/backend/app/organization/tax_id_validation.py -
// instant feedback on the org onboarding form; the backend still enforces
// the same rule on save. Corporate (org_type 2) -> GSTIN required.
// Individual (org_type 1) -> PAN required, GSTIN optional. Characters 3-12
// of a GSTIN are the holder's PAN, so when both are given they must agree.

const PAN_RE = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
const GSTIN_RE = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/;
const CHARSET = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';

export const normalizeTaxId = (v) => String(v || '').replace(/\s+/g, '').toUpperCase();

function gstinChecksumChar(first14) {
  let total = 0;
  for (let i = 0; i < first14.length; i++) {
    const product = CHARSET.indexOf(first14[i]) * (i % 2 ? 2 : 1);
    total += Math.floor(product / 36) + (product % 36);
  }
  return CHARSET[(36 - (total % 36)) % 36];
}

export function gstinError(gstin) {
  if (!GSTIN_RE.test(gstin)) return 'GSTIN format is invalid (15 characters: 2-digit state code + 10-character PAN + 3 characters).';
  const state = parseInt(gstin.slice(0, 2), 10);
  if (!(state >= 1 && state <= 38) && !['97', '99'].includes(gstin.slice(0, 2))) return 'GSTIN state code (first 2 digits) is invalid.';
  if (gstinChecksumChar(gstin.slice(0, 14)) !== gstin[14]) return "GSTIN check digit doesn't match - please re-check the number for typos.";
  return null;
}

export function panError(pan) {
  return PAN_RE.test(pan) ? null : 'PAN format is invalid (10 characters, e.g. ABCDE1234F).';
}

// Returns { gstin, pan } error messages (null when fine) for the form.
export function validateOrgTaxIds(orgType, rawGstin, rawPan) {
  const gstin = normalizeTaxId(rawGstin);
  const pan = normalizeTaxId(rawPan);
  const errors = { gstin: null, pan: null };

  if (gstin) errors.gstin = gstinError(gstin);
  else if (Number(orgType) === 2) errors.gstin = 'GSTIN is required for a Corporate organization.';

  if (pan) errors.pan = panError(pan);
  else if (Number(orgType) === 1) errors.pan = 'PAN is required for an Individual practitioner.';

  if (!errors.gstin && !errors.pan && gstin && pan && gstin.slice(2, 12) !== pan) {
    errors.pan = "PAN doesn't match the PAN inside the GSTIN (characters 3-12).";
  }
  return errors;
}
